const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./views/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// const index = () => import(/* webpackChunkName: "Home"*/ './views/Home');
// const addresses = () => import(/* webpackChunkName: "Addresses"*/ './views/customers/Addresses');
// const login = () => import(/* webpackChunkName: "Login"*/ './views/customers/Login');

export const AppViews = {
  // Customers
  // index: asyncComponentFactory('Home'),
};
